import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import type { AdminUserDetail } from '@/types/admin.types';
import { formatDateTime } from '@/utils/formatters';
import { Mail, Shield, Calendar, Clock } from 'lucide-react';

interface UserInfoCardProps {
  user: AdminUserDetail;
}

export function UserInfoCard({ user }: UserInfoCardProps) {
  return (
    <Card>
      <CardHeader title="Informations" />
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center gap-4">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-500/20 text-lg font-bold text-primary-400">
              {user.firstName[0]}{user.lastName[0]}
            </div>
            <div>
              <p className="font-semibold text-neutral-900 dark:text-neutral-100">{user.firstName} {user.lastName}</p>
              <div className="flex items-center gap-2 mt-1">
                <Badge variant={user.status === 'active' ? 'success' : user.isLocked ? 'danger' : 'neutral'}>
                  {user.isLocked ? 'Bloqué' : user.status}
                </Badge>
                {user.twoFactorEnabled && <Badge variant="info">2FA</Badge>}
              </div>
            </div>
          </div>

          <div className="space-y-3 text-sm">
            <div className="flex items-center gap-2 text-neutral-600 dark:text-neutral-400">
              <Mail className="h-4 w-4 text-neutral-400 dark:text-neutral-600" />
              <span>{user.email}</span>
            </div>
            <div className="flex items-center gap-2 text-neutral-600 dark:text-neutral-400">
              <Shield className="h-4 w-4 text-neutral-400 dark:text-neutral-600" />
              <span>Rôle: {user.role}</span>
            </div>
            <div className="flex items-center gap-2 text-neutral-600 dark:text-neutral-400">
              <Calendar className="h-4 w-4 text-neutral-400 dark:text-neutral-600" />
              <span>Inscrit le {formatDateTime(user.createdAt)}</span>
            </div>
            <div className="flex items-center gap-2 text-neutral-600 dark:text-neutral-400">
              <Clock className="h-4 w-4 text-neutral-400 dark:text-neutral-600" />
              <span>Dernière connexion: {user.lastLoginAt ? formatDateTime(user.lastLoginAt) : 'Jamais'}</span>
            </div>
          </div>

          {user.failedLoginAttempts > 0 && (
            <div className="rounded-lg bg-danger-500/10 p-3">
              <p className="text-xs text-danger-400">
                {user.failedLoginAttempts} tentative(s) de connexion échouée(s)
              </p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
